import React from "react";

export const IconOpenSpace = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m3.75 14.08v-4.12s2-3.52 3.55-3.52c0.36502-0.04342 0.73514-0.00345 1.0825 0.11688 0.34734 0.12034 0.66286 0.31792 0.92279 0.57785s0.45751 0.57545 0.57785 0.92279c0.12038 0.34735 0.16028 0.71747 0.11688 1.0825v8l3.1 5.4c0.9556-0.7099 1.7319-1.6335 2.2667-2.6971 0.5349-1.0635 0.8134-2.2374 0.8134-3.4279 0-1.1904-0.2785-2.3644-0.8134-3.4279-0.5348-1.0636-1.3111-1.9872-2.2667-2.6971m-5.8-3.85-2e-5 5c-0.05653 1.4678 0.45574 2.9007 1.43 4l1.27 1.72m9.25-6.86c-0.9538 0.7112-1.7284 1.6352-2.262 2.6986-0.5335 1.0634-0.8114 2.2367-0.8114 3.4264 0 1.1898 0.2779 2.363 0.8114 3.4264 0.5336 1.0634 1.3082 1.9875 2.262 2.6986m-7.39-12.25h8.64m-15.02 12.45 3.17-4.84m2.19-15.39c0 0.97754-0.7925 1.77-1.77 1.77-0.97754 0-1.77-0.79246-1.77-1.77s0.79246-1.77 1.77-1.77c0.97751 0 1.77 0.79246 1.77 1.77z"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconOpenSpace;
